import type { PropsWithChildren } from 'react'
import classNames from 'classnames'
import { Icon, type IconNames } from '../Icon'

export type Variation = 'success' | 'warning' | 'error' | 'information'

const variations: {
  [Key in Variation]: {
    text: string
    bg: string
    border: string
    icon: IconNames
  }
} = {
  success: {
    text: 'text-green-700',
    bg: 'bg-green-300',
    border: 'border-l-green-700',
    icon: 'checkCircle',
  },
  error: {
    text: 'text-red-600',
    bg: 'bg-red-200',
    border: 'border-l-red-600',
    icon: 'alertTriangleSolid',
  },
  warning: {
    text: 'text-yellow-700',
    bg: 'bg-yellow-300',
    border: 'border-l-yellow-500',
    icon: 'alertCircle',
  },
  information: {
    text: 'text-blue-600',
    bg: 'bg-blue-300',
    border: 'border-l-blue-600',
    icon: 'infoCircle',
  },
}

export type InlineNotificationProps = PropsWithChildren<{
  variation: Variation
  className?: string
}>

export function InlineNotification({
  children,
  variation,
  className = '',
}: InlineNotificationProps) {
  const { bg, text, border, icon } = variations[variation]

  return (
    <div
      className={classNames(
        `flex leading-[22px] ${bg} ${border} rounded-lg border-l-8 p-m text-base ${text} items-center gap-4`,
        className
      )}
      data-testid={`inline-notification-${variation}`}
    >
      <Icon id={icon} name={icon} color={text} className="self-start" />
      {children}
    </div>
  )
}
